import { z } from "zod";

export const AppRegistryQuerySchema = z.object({
  target: z.enum(["web", "desktop", "ios", "android"]).default("web"),
  channel: z.enum(["stable", "preview"]).default("stable"),
});

export const EffectiveAppRegistrySchema = z.object({
  subject: z.string(),
  revision: z.number().int().min(0),
  generatedAt: z.string().datetime(),
  apps: z.array(
    z.object({
      appId: z.string(),
      tier: z.enum(["free", "plus", "pro"]),
      release: z
        .object({
          version: z.string(),
          target: z.enum(["web", "desktop", "ios", "android"]),
          channel: z.enum(["stable", "preview"]),
          packageUrl: z.string().url(),
          sha256: z.string(),
          signature: z.string(),
          requiresClientVersion: z.string().nullable(),
          requiresSharedRuntimeVersion: z.string().nullable(),
        })
        .nullable(),
    }),
  ),
});

export type EffectiveAppRegistry = z.infer<typeof EffectiveAppRegistrySchema>;
